/**
 * Temporary in-house logo for Get Online Crew.
 * Self-contained inline SVG mark + wordmark. Swap this component to change
 * the logo everywhere.
 */
export const Logo = ({ variant = "dark", className = "" }) => {
  const wordColor = variant === "light" ? "#FFFFFF" : "#0B1220";
  const markStroke = variant === "light" ? "#FFFFFF" : "#0B1220";

  return (
    <span
      className={`inline-flex items-center gap-2 select-none ${className}`}
      data-testid="site-logo"
      aria-label="Get Online Crew"
    >
      <svg
        width="34"
        height="34"
        viewBox="0 0 34 34"
        aria-hidden="true"
        className="shrink-0"
      >
        <circle cx="17" cy="17" r="16" fill="#1688FF" />
        {/* upward rocket / launch mark */}
        <path
          d="M17 8 L21.5 17 L17 15 L12.5 17 Z"
          fill="#FFFFFF"
        />
        <path
          d="M14 20 L20 20"
          stroke={markStroke === "#FFFFFF" ? "#07111F" : "#FFFFFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M15 23 L19 23"
          stroke={markStroke === "#FFFFFF" ? "#07111F" : "#FFFFFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity="0.6"
        />
      </svg>
      <span
        className="text-[17px] font-bold tracking-tight leading-none"
        style={{ color: wordColor }}
      >
        Get Online <span style={{ color: "#1688FF" }}>Crew</span>
      </span>
    </span>
  );
};

export default Logo;
